import { format, intlFormatDistance } from 'date-fns';
import { getTransifexLocale, ISOLocaleToIETF } from '../i18n/getCurrentLocale';
// e.g. "4:23 PM"
export const TIME_SHORT = { timeStyle: 'short' };
// e.g. "Dec 20, 2020"
export const DATE_MEDIUM = { dateStyle: 'medium' };
// e.g. "Dec 20"
export const DATE_MEDIUM_PARTIAL = {
    day: 'numeric',
    month: 'short',
};
// e.g. "Sun, Dec 20, 2020"
export const DATE_MEDIUM_FULL = {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
};
// e.g. "December 20, 2020"
export const DATE_LONG = { dateStyle: 'long' };
// e.g. "Dec 20, 2020, 4:23 PM"
export const DATE_TIME_SHORT = Object.assign(Object.assign({}, DATE_MEDIUM), TIME_SHORT);
// e.g. "Sun, Dec 20, 2020, 4:23 PM"
export const DATE_TIME_MEDIUM = Object.assign(Object.assign({}, DATE_MEDIUM_FULL), { hour: 'numeric', minute: 'numeric' });
// e.g. "December 20, 2020 at 4:23 PM"
export const DATE_TIME_LONG = Object.assign(Object.assign({}, DATE_LONG), TIME_SHORT);
const intlFormatDateTime = (someDate, formatOptions = DATE_TIME_SHORT) => {
    const locale = getLocaleForFormatDate();
    return new Intl.DateTimeFormat(locale, formatOptions).format(someDate);
};
/*
 * formatDateTime formats date and time following the guidelines "Dates and times" of product content.
 * https://helios.lightspeedhq.com/document/57#/formatting/dates-and-times
 */
export const formatDateTime = (someDate, formatOptions = DATE_TIME_SHORT) => {
    const date = typeof someDate === 'string' ? new Date(someDate) : someDate;
    // check string type "formatOptions" for detecting deprecated formats
    if (typeof formatOptions === 'string') {
        return format(date, formatOptions);
    }
    else {
        return intlFormatDateTime(date, formatOptions);
    }
};
export const formatDateDistance = (fromDate, toDate = new Date()) => {
    const locale = getLocaleForFormatDate();
    return intlFormatDistance(fromDate, toDate, { locale });
};
export function getLocaleForFormatDate() {
    const txLocale = getTransifexLocale();
    return ISOLocaleToIETF(txLocale);
}
